import {
  AlertTriangle,
  LoaderCircle,
  X,
} from "lucide-react";

function ConfirmDialog({
  isOpen,
  title,
  description,
  confirmLabel = "Confirm",
  isWorking = false,
  tone = "danger",
  onCancel,
  onConfirm,
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="admin-modal-backdrop">
      <section
        className="admin-confirm-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
      >
        <button
          type="button"
          className="admin-confirm-dialog__close"
          onClick={onCancel}
          disabled={isWorking}
          aria-label="Close confirmation"
        >
          <X size={20} />
        </button>

        <div
          className={[
            "admin-confirm-dialog__icon",
            `admin-confirm-dialog__icon--${tone}`,
          ].join(" ")}
        >
          <AlertTriangle size={24} />
        </div>

        <div className="admin-confirm-dialog__content">
          <h2 id="confirm-dialog-title">{title}</h2>
          <p>{description}</p>
        </div>

        <div className="admin-confirm-dialog__actions">
          <button
            type="button"
            className="btn btn--secondary"
            onClick={onCancel}
            disabled={isWorking}
          >
            Cancel
          </button>

          <button
            type="button"
            className="btn admin-danger-button"
            onClick={onConfirm}
            disabled={isWorking}
          >
            {isWorking && (
              <LoaderCircle
                size={17}
                className="admin-spin"
              />
            )}

            {isWorking ? "Deleting..." : confirmLabel}
          </button>
        </div>
      </section>
    </div>
  );
}

export default ConfirmDialog;